export const iconFontAwesomePhotosImagesEye = (
	<i className="fa-solid fa-eye"></i>
);
